
export function userIdentify (events) {
  return store =>
    store.subscribe(({ type, payload }) => {
      if (type === 'user/setMe') {
        events.$emit(events.USER_IDENTIFY, { id: payload.id });
      }
    });
}
